// Drive Theme - Cart Plus/Minus Fix
document.addEventListener('click', function(e) {
  // Only trigger for plus/minus buttons
  if (e.target.matches('.cart__qty-adjust, .quantity-selector button')) {
    const isPlus = e.target.classList.contains('plus') || e.target.dataset.action === 'increase';
    const isMinus = e.target.classList.contains('minus') || e.target.dataset.action === 'decrease';

    const container = e.target.closest('.cart__item, .quantity-selector');
    if (!container) return;

    const input = container.querySelector('input[type="number"]');
    if (!input) return;

    let value = parseInt(input.value) || 1;
    if (isPlus) value++;
    if (isMinus && value > 1) value--;
    input.value = value;

    // Trigger change for theme listeners
    input.dispatchEvent(new Event('change'));

    // Update Shopify cart via AJAX
    if (input.name && input.name.startsWith('updates')) {
      const formData = {
        id: input.dataset.line || input.dataset.id,
        quantity: value
      };
      if (formData.id) {
        fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: formData.id, quantity: value })
        })
        .then(res => res.json())
        .then(() => {
          // Optional: refresh cart drawer or totals
          if (typeof window.updateCartTotals === 'function') window.updateCartTotals();
        });
      }
    }
  }
});
